// index.ts
import { useEffect, useRef, useState } from "react";
import State, { on, off, pure } from "minimal-state";
import { set, update, once, emit, clear, next, is, until } from "minimal-state";
function use(state, key) {
  let [, setState] = useState(0);
  let newKeys = key instanceof Array ? key : [key];
  let keys = useStableArray(newKeys);
  useEffect(() => {
    let isOff = false;
    let updater = () => {
      if (!isOff) setState(n => n + 1);
    };
    for (let key2 of keys) {
      on(state, key2, updater);
    }
    return () => {
      isOff = true;
      for (let key2 of keys) {
        off(state, key2, updater);
      }
    };
  }, [keys]);
  return key instanceof Array ? keys.map(key2 => state[key2]) : key === void 0 ? pure(state) : state[key];
}
function UsableState(initialState, options) {
  let state = State(initialState, {
    ...options,
    minimal: false
  });
  return Object.assign(state, {
    use(key) {
      return use(state, key);
    }
  });
}
function useStableArray(newArray) {
  let oldArrayRef = useRef(newArray);
  let oldArray = oldArrayRef.current;
  let stableArray = arrayEqual(oldArray, newArray) ? oldArray : newArray;
  useEffect(() => {
    oldArrayRef.current = stableArray;
  }, [stableArray]);
  return stableArray;
}
function arrayEqual(a, b) {
  if (a === b) return true;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}
export { clear, UsableState as default, emit, is, next, off, on, once, pure, set, until, update, use };